/* eslint-disable import/prefer-default-export */
const defaultColumns = [
  {
    field: 'name',
    title: `Active Ingredient`,
    width: '50%',
    sortable: true
  },
  {
    field: 'totalQuantity',
    title: `Quantity per Acre`,
    width: '50%',
    sortable: true
  }
];

export const defaultSort = {
  dir: 'asc',
  field: 'totalQuantity'
};

export const CROPZONE_ACTIVE_INGREDIENTS_TABLE = {
  columns: defaultColumns,
  initialSort: defaultSort,
  defaultValueUnit: 'lbs / ac'
};
